var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ld-button',{staticClass:"button-toggle-expand",attrs:{"color":"dark","icon-pack":"feather","icon":"icon-maximize-2","type":"flat","disabled":_vm.disabled},on:{"click":function () { return _vm.expandElement(
        _vm.expandedElementId,
        _vm.expandedElementWrap,
        _vm.onTogleExpansion
    ); }}})}
var staticRenderFns = []

export { render, staticRenderFns }